<template>
  <div ref="loadMoreRef"></div>
</template>

<script setup lang="ts">
import { useElementVisibility, useMounted, watchDebounced } from '@vueuse/core';
import { useTemplateRef } from 'vue';

const emit = defineEmits(['inView', 'outOfView']);

const loadMoreRef = useTemplateRef<HTMLDivElement | undefined>('loadMoreRef');
const inView = useElementVisibility(loadMoreRef);
const mounted = useMounted();

watchDebounced(
  () => inView.value,
  () => {
    if (inView.value && mounted) {
      emit('inView');
    } else {
      emit('outOfView');
    }
  },
  {
    debounce: 100,
    immediate: false,
  }
);
</script>
